import React from "react";
import skillImg from "../../../assets/images/skill/skill1.png";
import "./mySkills.css";

const MySkills = () => {
  const skills = [
    {
      id: 1,
      skill: "HTML5",
    },
    {
      id: 2,
      skill: "CSS3",
    },
    {
      id: 3,
      skill: "SASS",
    },
    {
      id: 4,
      skill: "Bootstrap 5",
    },
    {
      id: 5,
      skill: "Tailwind",
    },
    {
      id: 7,
      skill: "JavaScript",
    },
    {
      id: 8,
      skill: "React",
    },
    {
      id: 9,
      skill: "NodeJS",
    },
    {
      id: 10,
      skill: "MongoDB",
    },
    {
      id: 11,
      skill: "Express",
    },
    {
      id: 12,
      skill: "Material UI",
    },
    {
      id: 13,
      skill: "Firebase",
    },
    {
      id: 14,
      skill: "JWT",
    },
    {
      id: 15,
      skill: "Rest API",
    },
    {
      id: 16,
      skill: "WordPress",
    },
    {
      id: 17,
      skill: "PHP",
    },
    {
      id: 18,
      skill: "MySQL",
    },
    {
      id: 19,
      skill: "jQuery",
    },
  ];

  const tools = [
    {
      id: 1,
      tool: "gitHub",
    },
    {
      id: 2,
      tool: "VS Code",
    },
    {
      id: 3,
      tool: "Figma",
    },
    {
      id: 4,
      tool: "Chrome dev tool",
    },
    {
      id: 5,
      tool: "MS Office",
    },
  ];
  return (
    <section id="mySkills" className="bg-main text-white">
      <div id="sectionTitle" className="sectionTitle pt-32 pb-5 text-center">
        <h2 className="text-5xl font-bold">My Skills</h2>
      </div>
      <div className="container flex flex-col justify-center p-6 mx-auto sm:py-12 lg:py-24 lg:flex-row gap-5">
        <div className=" text-left ">
          <div>
            <h3 className="text-2xl mb-3">Expertise on</h3>
            <ul className="flex flex-wrap gap-4 ">
              {skills.map((skill) => (
                <li key={skill.id} className="mySkillBtn">
                  {skill.skill}
                </li>
              ))}
            </ul>
          </div>
          <div className="mt-5">
            <h3 className="text-2xl mb-3">Tools</h3>
            <ul className="flex flex-wrap gap-4 ">
              {tools.map((tool) => (
                <li key={tool.id} className="mySkillBtn">
                  {tool.tool}
                </li>
              ))}
            </ul>
          </div>
        </div>
        <div>
          <img src={skillImg} alt="" className="object-contain w-5/6 h-5/6" />
        </div>
      </div>
    </section>
  );
};

export default MySkills;
